import api from './api';

export const workdayService = {
  // Get user's complete weekly schedule
  getUserWeeklySchedule: () => {
    return api.get('/workday-settings/user/weekly');
  },
  
  // Update user's complete weekly schedule
  updateUserWeeklySchedule: (schedule) => {
    return api.put('/workday-settings/user/weekly', schedule);
  },
  
  // Get all user workday settings
  getUserWorkdaySettings: () => {
    return api.get('/workday-settings/user');
  },
  
  // Create a new user workday setting
  createUserWorkdaySetting: (setting) => {
    return api.post('/workday-settings/user', setting);
  },
  
  // Update a specific day's workday setting
  updateUserWorkdaySetting: (dayOfWeek, setting) => {
    return api.put(`/workday-settings/user/${dayOfWeek}`, setting);
  },
  
  // Delete a user workday setting (reverts to firm default)
  deleteUserWorkdaySetting: (dayOfWeek) => {
    return api.delete(`/workday-settings/user/${dayOfWeek}`);
  },
  
  // Get firm workday defaults (admin only)
  getFirmWorkdayDefaults: () => {
    return api.get('/workday-settings/firm');
  },
  
  // Update firm workday default (admin only)
  updateFirmWorkdayDefault: (dayOfWeek, setting) => {
    return api.put(`/workday-settings/firm/${dayOfWeek}`, setting);
  },
};